import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';

@Component({
  selector: 'etxe-explore-details-skeleton',
  imports: [NgxSkeletonLoaderComponent],
  templateUrl: './explore-details-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExploreDetailsSkeletonComponent {}
